import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Wie erhalte ich das Material?',
  a: 'Sofort nach dem Kauf per E-Mail als digitaler PDF-Download. Kompatibel mit Smartphone, Tablet und Desktop.'
}, {
  q: 'Ist das System für Expats geeignet?',
  a: 'Absolut. Es wurde speziell entwickelt, um die "Touristen-Steuer" zu eliminieren — für alle, die in der Schweiz leben.'
}, {
  q: 'Sind die Infos auf dem neusten Stand?',
  a: 'Ja. Alle Preise und Tarife sind für die Saison 2025/2026 aktualisiert.'
}, {
  q: 'Brauche ich ein Halbtax?',
  a: 'Nein. Das System zeigt Optionen für jede Preislage. Mit Halbtax ist die Ersparnis jedoch maximal.'
}, {
  q: 'Wie lange habe ich Zugriff auf die Inhalte?',
  a: 'Lebenslang. Einmalzahlung — dauerhafter Zugriff.'
}, {
  q: 'Brauche ich teure Ausrüstung?',
  a: 'Nein. Tomo 3 zeigt Ihnen genau, wie Sie Profi-Ausrüstung für 10% des Neupreises bekommen.'
}, {
  q: 'Funktioniert es für Familien mit Kindern?',
  a: 'Ja. Es gibt ein spezielles Modul für Kinder-Gratis-Stationen und das Ausrüstungs-Rotations-System.'
}, {
  q: 'Kann ich es nutzen, wenn ich nicht Ski fahre?',
  a: 'Das Gastronomie- und Transport-System funktioniert auch für Winterwanderungen und Schneeschuh-Touren.'
}, {
  q: 'Wie funktioniert die 7-Tage-Garantie?',
  a: 'Schicken Sie uns eine E-Mail innerhalb von 7 Tagen. Wir erstatten jeden Rappen. Ohne Fragen.'
}, {
  q: 'Welche Zahlungsmethoden werden akzeptiert?',
  a: 'Kreditkarte, Twint, PayPal und Banküberweisung.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 px-4 bg-brand-dark" data-id="element-82">
      <div className="max-w-xl mx-auto" data-id="element-83">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-black text-center mb-8 text-brand-cream" data-id="element-84">
          Häufig gestellte Fragen
        </motion.h2>

        <div className="space-y-3" data-id="element-85">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-brand-card border border-white/10 rounded-xl overflow-hidden" data-id="element-86">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-white/5 transition-colors gap-3" data-id="element-87">
                <span className="font-bold text-brand-cream text-sm sm:text-base" data-id="element-88">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-orange transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-89" />
              </button>

              <AnimatePresence data-id="element-90">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-91">
                    <div className="px-5 pb-4 pt-0 text-sm text-gray-400 font-medium leading-relaxed" data-id="element-92">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}